// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__98Sw9","content":"Tooltip_content__9Bz2p"};